// import { enableProdMode } from '@angular/core';
// import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

// import { AppModule } from './app/app.module';
// import { environment } from './environments/environment';

// if (environment.production) {
//   enableProdMode();
// }

// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.error(err));

// import { enableProdMode } from '@angular/core';
// import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

// import { AppModule } from './app/app.module';
// import { environment } from './environments/environment';

// if (environment.production) {
//   enableProdMode();
// }

// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.error(err));


import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {enableProdMode} from '@angular/core';
import {environment} from './environments/environment';
import {environment as local} from './environments/environment';
import {environment as dev} from './environments/environment.dev';
import {environment as qa} from './environments/environment.qa';
import {environment as prod} from './environments/environment.prod';
 
declare var window: any;
 
// Define all available environments
export const environments = {
  default: local,
  dev: dev,
  prod: prod,
  qa: qa
};
 
// Export environment variable that will be updated at runtime
export let environment1 = local;
 
// Runtime environment selection logic
let hostname = (window.location && window.location.hostname) ? window.location.hostname.toLowerCase() : null;
if (hostname === 'www.toyotatours.com' || hostname === 'www.tourtoyota.com') {
  hostname = 'tour.toyota.com';
}
let environmentType = environments.default;
 
// Get all environment names except 'default'
const environmentNames: string[] = Object.keys(environments).filter(envName => envName !== 'default');
 
// Find environment by matching hostname
let selectedEnvName = environmentNames.find(envName => {
  if (environments[envName] && environments[envName].hostname) {
    return environments[envName].hostname.toLowerCase() === hostname;
  } else {
    return false;
  }
});
 
// Override default behavior by setting window.environment in index.html
if (window['environment'] && environments[window['environment']]) {
  selectedEnvName = window['environment'];
}
 
// Set the selected environment
if (!selectedEnvName) {
  selectedEnvName = 'default';
} else if (selectedEnvName && environments[selectedEnvName]) {
  environmentType = environments[selectedEnvName];
}
 
// Update environment name
environmentType.envName = selectedEnvName;
 
// Apply runtime environment to the exported environment object
environment1 = environmentType;
 
// Copy all properties from selected environment to the default environment object
// This ensures existing imports of 'environment' get the correct config
// We need to copy descriptors to preserve getters
const envDescriptors = Object.getOwnPropertyDescriptors(environmentType);
Object.keys(envDescriptors).forEach(key => {
  Object.defineProperty(environment, key, envDescriptors[key]);
});
 
// Enable production mode if applicable
if (environmentType.production) {
  enableProdMode();
}
 
// Defer loading AppModule until after runtime environment selection
import('./app/app.module').then(({ AppModule }) => {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
});